import React, { FC, ReactNode } from 'react'

import { Button, FiftyFifty, Typography } from '@smarty-nx/ds'
import { DATA_LAYER_EVENTS, TRACKING_CATEGORIES } from '@smarty-nx/tracking'

import classes from './hero.module.scss'
import {
  CheckIcon,
  ListItem,
  ListParagraphSmall,
} from '../../components/shared'
import TextLink from '../../components/TextLink'
import CheckImage from '../../static/images/checkmark.svg'

interface HeroProps {
  heading: string
  subHeading: string
  subTitle?: string
  subLink?: string
  sublinkSuffix?: ReactNode
  benefits?: string[]
  CTA?: string
  CTALink?: string
  image?: ReactNode
  imageUrl?: string
  hideButton?: boolean
  imageAlt?: string
}

const Hero: FC<HeroProps> = ({
  heading,
  subHeading,
  subTitle,
  subLink,
  sublinkSuffix,
  benefits,
  CTA,
  CTALink,
  image,
  imageUrl,
  hideButton,
  imageAlt = '',
}) => (
  <FiftyFifty inverse className={classes.heroWrapper}>
    <div className={classes.imageWrapper}>
      {image ?? (
        <div
          className={classes.image}
          role="img"
          aria-label={imageAlt}
          style={
            {
              '--hero-image-url': `url(${imageUrl ?? ''})`,
            } as React.CSSProperties
          }
        />
      )}
    </div>
    <div className={classes.contentWrapper}>
      <Typography
        component="h1"
        variant="Kollektif/ExtraLarge"
        className={classes.heading}
      >
        {heading}
      </Typography>
      {subHeading && (
        <Typography
          variant="Kollektif/MediumEmphasis"
          className={classes.subHeading}
        >
          {subHeading}
          {subLink && (
            <>
              <TextLink href={subLink}>{subTitle}</TextLink>
              {sublinkSuffix}
            </>
          )}
        </Typography>
      )}
      <ul className={classes.benefitsWrapper}>
        {benefits?.map((item, index) => (
          <ListItem key={index}>
            <CheckIcon src={CheckImage} alt="" />
            <ListParagraphSmall>{item}</ListParagraphSmall>
          </ListItem>
        ))}
      </ul>
      {!hideButton && (
        <Button
          as={(props) => (
            <a {...props} href={CTALink}>
              {CTA}
            </a>
          )}
          dataItemCategory={TRACKING_CATEGORIES.GENERAL}
          dataItemName={DATA_LAYER_EVENTS.HERO_STRING}
        />
      )}
    </div>
  </FiftyFifty>
)

export default Hero
